import React from "react";
import QuestionnaireReportButtons from "@common/components/questionnaireComponents/questionnaireReportButtons/QuestionnaireReportButtons";
import QuestionnaireReportOverflowButtons from "@common/components/questionnaireComponents/questionnaireReportButtons/QuestionnaireReportOverflowButtons";
import { useTranslation } from "@localization/useTranslation";
import { LegalEntityAuditStatus } from "../../legalEntity/legalEntityAuditTab/LegalEntityAudit.types";
import { InternalAssessmentApiRow } from "../InternalAssessments.types";

export interface InternalAssessmentReportButtonsProps {
    row: InternalAssessmentApiRow;
    isDownloadingPdf: boolean;
    reportPdfUrl: string;
    onDownloadReportPdf: (row: InternalAssessmentApiRow, isSimpleReport: boolean, showRecommendations: boolean) => void;
}

function InternalAssessmentReportButtons(props: InternalAssessmentReportButtonsProps) {
    const { translateString } = useTranslation();

    if (!props.row.partOfCurrentPlan) {
        return undefined;
    }

    const showButtons = props.row.status !== LegalEntityAuditStatus.Opened && props.row.status !== LegalEntityAuditStatus.Sent && !props.row.isClosed;

    function getMenuItems() {
        if (props.row.scoreEnabled) {
            return [
                {
                    menuItem: props.row.hasRecommendations ? translateString("downloadWithScoreAndRecommendations") : translateString("downloadWithScore"),
                    onClick: () => props.onDownloadReportPdf(props.row, false, props.row.hasRecommendations),
                },
                {
                    menuItem: props.row.hasRecommendations
                        ? translateString("downloadWithoutScoreAndRecommendations")
                        : translateString("downloadWithoutScore"),
                    onClick: () => props.onDownloadReportPdf(props.row, true, false),
                },
            ];
        }

        return [
            { menuItem: translateString("downloadWithRecommendations"), onClick: () => props.onDownloadReportPdf(props.row, false, true) },
            { menuItem: translateString("downloadWithoutRecommendations"), onClick: () => props.onDownloadReportPdf(props.row, false, false) },
        ];
    }

    if (props.row.scoreEnabled || props.row.hasRecommendations) {
        return (
            <QuestionnaireReportOverflowButtons
                reportPdfUrl={props.reportPdfUrl}
                reportPdfMenuItems={getMenuItems()}
                showButtons={showButtons}
                isDownloadingPdf={props.isDownloadingPdf}
            />
        );
    }

    return (
        <QuestionnaireReportButtons
            isDownloadingPdf={props.isDownloadingPdf}
            onDownloadReportPdf={() => props.onDownloadReportPdf(props.row, true, false)}
            reportPdfUrl={props.reportPdfUrl}
            showButtons={showButtons}
        />
    );
}

export default InternalAssessmentReportButtons;
